import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"

export default class CorService extends ServiceBase {

    title = "Cor"
    pluralTitle = "Cors"
    url = '/cadastro/produto/cor'
    frontUrl = '/cadastro/produto/cor'
    frontUrlList = '/cadastro/produto/corlist'
    primaryKey = 'codigo_cor'
    ignoredsSchemaConvertions = ['cod_emp_cor']

    prepareToFront(data = {}) {

        data.ativo_cor = boolToNumber(data.ativo_cor, true)

        return data
    }

    prepareToSave({ data }) {

        data.ativo_cor = boolToNumber(data.ativo_cor)

        delete data.meta

        return data

    }

}
